import { render, staticRenderFns } from "./ChildSupportOrderAgreement.vue?vue&type=template&id=5341b6ac"
import script from "./ChildSupportOrderAgreement.vue?vue&type=script&lang=ts"
export * from "./ChildSupportOrderAgreement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports